import { ContentKey } from '@careerhub/content-shared';
import { Site } from '@careerhub/content-shared';
import { createAction } from 'typesafe-actions';
import { IdModel } from '../../../models/id.models';

export const contentSetActive = createAction('CONTENT:SET_ACTIVE')<{ key: ContentKey }>();

export const siteUpdate = createAction('SITE:UPDATE')<Partial<Site> & IdModel>();
